import { StyledGridColumnProps } from '@components/Grid/Grid.model';
import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

export const ExtraContentLayout = styled.div<{ bgImg: any }>`
  padding: 96px 0;
width: 100%:
height : fit-content;
  
  ${({ bgImg }) =>
    bgImg &&
    `
    background-image: url(${bgImg});
    background-size: cover;            
    background-repeat: no-repeat;      
    background-position: center;      
  `}

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY}{
  padding : 64px 0 ;
  }
`;

export const ExtraContentSection = styled.div`
  width: 100%;
  height: fit-content;

  overflow-x: hidden;
  overflow-y: hidden;
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
  }
`;

export const ExtraContentCard = styled.div<{ bgImg: any }>`
  flex: 0 0 auto;

  width: 380px;
  aspect-ratio: 380 /200;
  border-radius: 16px;
  background: #000;

  ${({ bgImg }) =>
    bgImg &&
    `
    background-image: url(${bgImg});
    background-size: 108%;            
    background-repeat: no-repeat;      
    background-position: center;      
  `}

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    width: 322px;
    aspect-ratio: 322 / 300;
  }
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    width: 322px;
    aspect-ratio: 361 / 240;
  }
`;
